
define('text!platform/commonUI/inspect/res/info-bubble.html',[],function () { return '<mct-container\n\tkey="bubble"\n\tbubble-title="{{parameters.title}}"\n\tbubble-layout="{{parameters.layout}}"\n\t>\n    <mct-include key="info-table"\n                 ng-model="ngModel">\n    </mct-include>\n</mct-container>\n';});

